import { shuffleTurnOrder } from '@utils/turnManager';

/**
 * Generate squiggle–transform pairs from a list of member IDs.
 * Shuffles members, then pairs adjacent: [A,B], [C,D], etc.
 * With an odd count, the last person wraps to pair with the first.
 * Solo play: the single player is both squiggler and transformer.
 *
 * @param {string[]} memberIds
 * @returns {Array<{ squiggler: string, transformer: string, pairIndex: number }>}
 */
export function generatePairs(memberIds) {
  if (!memberIds || memberIds.length === 0) return [];

  // Solo mode — same person does both roles
  if (memberIds.length === 1) {
    return [{ squiggler: memberIds[0], transformer: memberIds[0], pairIndex: 0 }];
  }

  const shuffled = shuffleTurnOrder(memberIds);
  const pairs = [];

  for (let i = 0; i < shuffled.length; i += 2) {
    const squiggler = shuffled[i];
    // With odd count, last person wraps to pair with first
    const transformer = i + 1 < shuffled.length
      ? shuffled[i + 1]
      : shuffled[0];

    pairs.push({
      squiggler,
      transformer,
      pairIndex: pairs.length,
    });
  }

  return pairs;
}
